import type {ScriptData} from '@/components/platform/types'
import { hasExplicitWebClientExecAttr } from '@/common/utils/webClientExec'

export { hasExplicitWebClientExecAttr }

/** Текст скрипта `event.dialogClosed` */
export function getDialogClosedScriptText(
  action: Record<string, any> | null | undefined,
): string | undefined {
  if (!action || typeof action !== 'object') return undefined
  const flat = action['event.dialogClosed']
  if (typeof flat === 'string' && flat.trim()) return flat.trim()
  if (flat && typeof flat === 'object' && typeof flat._text === 'string' && flat._text.trim()) {
    return flat._text.trim()
  }
  const ev = action.event
  if (ev && typeof ev === 'object') {
    const dc = (ev as { dialogClosed?: { _text?: string } | string }).dialogClosed
    if (typeof dc === 'string' && dc.trim()) return dc.trim()
    if (dc && typeof dc === 'object' && typeof dc._text === 'string' && dc._text.trim()) {
      return dc._text.trim()
    }
  }
  return undefined
}

/** Узел `event.dialogClosed` из метаданных action */
export function getDialogClosedScriptNode(
  action: Record<string, any> | null | undefined,
): ScriptData | undefined {
  if (!action || typeof action !== 'object') return undefined
  const flat = action['event.dialogClosed']
  if (flat && typeof flat === 'object') return flat as ScriptData
  if (typeof flat === 'string') return {_text: flat} as ScriptData
  const ev = action.event
  const dc = ev?.dialogClosed
  if (dc && typeof dc === 'object') return dc as ScriptData
  if (typeof dc === 'string') return {_text: dc} as ScriptData
  return undefined
}

/** Текст скрипта `event.dialogClosedNReturn` */
export function getDialogClosedNReturnScriptText(
  action: Record<string, any> | null | undefined,
): string | undefined {
  if (!action || typeof action !== 'object') return undefined
  const flat = action['event.dialogClosedNReturn']
  if (typeof flat === 'string' && flat.trim()) return flat.trim()
  if (flat && typeof flat === 'object' && typeof flat._text === 'string' && flat._text.trim()) {
    return flat._text.trim()
  }
  const ev = action.event
  if (ev && typeof ev === 'object') {
    const n = (ev as { dialogClosedNReturn?: { _text?: string } | string }).dialogClosedNReturn
    if (typeof n === 'string' && n.trim()) return n.trim()
    if (n && typeof n === 'object' && typeof n._text === 'string' && n._text.trim()) {
      return n._text.trim()
    }
  }
  return undefined
}

/** Узел `event.dialogClosedNReturn` из метаданных action. */
export function getDialogClosedNReturnScriptNode(
  action: Record<string, any> | null | undefined,
): ScriptData | undefined {
  if (!action || typeof action !== 'object') return undefined
  const flat = action['event.dialogClosedNReturn']
  if (flat && typeof flat === 'object') return flat as ScriptData
  if (typeof flat === 'string') return { _text: flat } as ScriptData
  const ev = action.event
  const n = ev?.dialogClosedNReturn
  if (n && typeof n === 'object') return n as ScriptData
  if (typeof n === 'string') return { _text: n } as ScriptData
  return undefined
}
